import { liveMatches } from "@/mocks/sportsData";
import LiveMatchCard from "./LiveMatchCard";

export default function LiveMatchesSection() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              热门赛事直播
            </h2>
            <p className="text-sm text-foreground-500 mt-1">
              实时追踪全球顶级赛事，精彩不容错过
            </p>
          </div>
          <a href="#" className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap">
            查看全部
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {liveMatches.map((match) => (
            <LiveMatchCard key={match.id} match={match} />
          ))}
        </div>
      </div>
    </section>
  );
}